<div class="detail-modal-footer">
  <span>
    {{ 'created_at' | translate }}
    {{ (createdAt | localizedDate: 'dd MMMM yyyy') ?? '-' }}
    {{ 'at' | translate }}
    {{ (createdAt | localizedDate: 'HH:mm') ?? '-' }}
    {{ 'by' | translate }}
    {{ createdBy ?? '-' }}
  </span>
  @if (updatedAt && updatedBy) {
    <span>
      {{ 'updated_at' | translate }}
      {{ (updatedAt | localizedDate: 'dd MMMM yyyy') ?? '-' }}
      {{ 'at' | translate }}
      {{ (updatedAt | localizedDate: 'HH:mm') ?? '-' }}
      {{ 'by' | translate }}
      {{ updatedBy ?? '-' }}
    </span>
  }
</div>
